import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BlockIcon from '@mui/icons-material/Block';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { CartApprovalDetails, CartApprovalStatus } from 'src/types';
import { LinkWrapper, ShowTooltipWrapper } from './CartApprovalTooltipHelpers';

type Props = {
  cartApprovalDetails: CartApprovalDetails | null;
  cartApprovalStatus: CartApprovalStatus;
  requestedByEmail: string;
  includeLink: boolean;
  linkPage: 'get' | 'review' | 'history';
  cartId: string;
  fromHistory: boolean;
  whitePendingStatus: boolean;
  pendingTextDisplay: string;
  page: 'get' | 'review' | 'history';
  handleContinue?: (skipApproval: boolean) => void;
};

export const CartApprovedPendingRejected = ({
  cartApprovalStatus,
  requestedByEmail,
  includeLink,
  linkPage,
  cartId,
  fromHistory,
  whitePendingStatus,
  pendingTextDisplay,
  page,
  handleContinue,
}: Props) => {
  if (cartApprovalStatus === 'pending') {
    return (
      <ShowTooltipWrapper
        requestedByEmail={requestedByEmail}
        cartApprovalStatus={cartApprovalStatus}
      >
        <LinkWrapper
          includeLink={includeLink}
          page={linkPage}
          cartId={cartId}
          fromHistory={fromHistory}
        >
          <button
            className={`${whitePendingStatus ? 'border-offWhite text-offWhite' : 'border-primary-dark text-primary-dark'} flex min-h-[36px] flex-row flex-nowrap items-center justify-center gap-2 truncate whitespace-nowrap rounded border border-dashed bg-transparent px-4 py-1 font-semibold transition-all`}
          >
            {pendingTextDisplay}
            <AccessTimeIcon
              style={{ fontSize: 16 }}
              className={`${whitePendingStatus ? 'text-white' : 'text-primary-dark'}`}
            />
          </button>
        </LinkWrapper>
      </ShowTooltipWrapper>
    );
  }

  if (cartApprovalStatus === 'approved') {
    return (
      <LinkWrapper includeLink={true} page={'get'} cartId={cartId} fromHistory={fromHistory}>
        <button className='flex min-h-[36px] flex-row flex-nowrap items-center justify-center gap-2 truncate whitespace-nowrap rounded border border-grassGreen bg-grassGreen px-4 py-1 font-semibold text-white transition-all'>
          Approved
          <TaskAltIcon style={{ fontSize: 16 }} className='text-white' />
        </button>
      </LinkWrapper>
    );
  }

  if (cartApprovalStatus === 'rejected') {
    // if the user is on the get page and the cart's been rejected,
    // we want to allow the user to submit the cart again or simply load the items.
    if (page === 'get') {
      // throw an error that will be caught by livesession.
      if (!handleContinue) {
        console.error('handleContinue is not a function');
      }

      return (
        <button
          onClick={() => !!handleContinue && handleContinue(false)}
          disabled={!handleContinue}
          className='flex min-h-[36px] flex-row flex-nowrap items-center justify-center gap-2 truncate whitespace-nowrap rounded border border-rose-500 bg-rose-500 px-4 py-1 font-semibold text-white transition-all disabled:opacity-70'
        >
          Rejected
          <BlockIcon style={{ fontSize: 16 }} className='text-white' />
        </button>
      );
    }

    return (
      <ShowTooltipWrapper
        requestedByEmail={requestedByEmail}
        cartApprovalStatus={cartApprovalStatus}
      >
        <LinkWrapper
          includeLink={includeLink}
          page={linkPage}
          cartId={cartId}
          fromHistory={fromHistory}
        >
          <button className='flex min-h-[36px] flex-row flex-nowrap items-center justify-center gap-2 truncate whitespace-nowrap rounded border border-rose-500 bg-rose-500 px-4 py-1 font-semibold text-white transition-all'>
            Rejected
            <BlockIcon style={{ fontSize: 16 }} className='text-white' />
          </button>
        </LinkWrapper>
      </ShowTooltipWrapper>
    );
  }

  return null;
};
